import { z } from 'zod';
export var VoiceExecutionMessageType;
(function (VoiceExecutionMessageType) {
    VoiceExecutionMessageType["PROMPT"] = "prompt";
    VoiceExecutionMessageType["STATIC_TEXT"] = "static_text";
})(VoiceExecutionMessageType || (VoiceExecutionMessageType = {}));
export const voiceExecutionConfigPatchSchema = z.strictObject({
    executionMessageType: z.nativeEnum(VoiceExecutionMessageType).optional(),
    executionMessage: z.string().optional(),
    speakDuringExecution: z.boolean().optional(),
    speakAfterExecution: z.boolean().optional(),
    enableTypingSound: z.boolean().optional(),
});
export const voiceExecutionConfigSchema = voiceExecutionConfigPatchSchema.superRefine(({ executionMessageType, executionMessage }, context) => {
    const staticMessageIsEmpty = executionMessageType === VoiceExecutionMessageType.STATIC_TEXT && !executionMessage?.trim();
    if (staticMessageIsEmpty) {
        context.addIssue({
            code: 'custom',
            path: ['executionMessage'],
            message: 'Enter a waiting message for static text.',
        });
    }
});
export const VOICE_EXECUTION_DEFAULTS = {
    executionMessageType: VoiceExecutionMessageType.PROMPT,
    speakDuringExecution: false,
    speakAfterExecution: true,
    enableTypingSound: true,
};
//# sourceMappingURL=tool-voice-execution.js.map